/**
 * Canonical Legal link set.
 * Owner-approved 8-link parity for public Footer, LegalFooter, and
 * Patient Settings → Legal. Cookie Policy (legal document) and
 * Cookie Settings (preference centre) are separate functions.
 */
export const LEGAL_LINKS = [
  { to: '/terms',                label: 'Terms of Service',       testid: 'legal-link-terms' },
  { to: '/privacy',              label: 'Privacy Policy',         testid: 'legal-link-privacy' },
  { to: '/cookie-policy',        label: 'Cookie Policy',          testid: 'legal-link-cookie-policy' },
  { to: '/cookie-settings',      label: 'Cookie Settings',        testid: 'legal-link-cookie-settings' },
  { to: '/refund-policy',        label: 'Cancellation & Refund',  testid: 'legal-link-refund' },
  { to: '/health-tourism-info',  label: 'Health Tourism Information', testid: 'legal-link-hti' },
  { to: '/open-source',          label: 'Open Source Licences',   testid: 'legal-link-oss' },
  { to: '/contact',              label: 'Contact',                testid: 'legal-link-contact' },
];
